import moment from "moment";

import { Constants } from "../../../shared/constants/constants";
import { CronObject, CurrentSchedule } from "../../../shared/models";

export const createCronExpression = (cronObject: CronObject): string => {
  const { seconds = "00", minutes = "00", hours = "00", dayOfMonth = "?", month = "*", dayOfWeek = "*" } = cronObject;

  const validSeconds = validate(String(seconds), /^[0-5]?[0-9]$/, "00").padStart(2, "0");
  const validMinutes = validate(String(minutes), /^[0-5]?[0-9]$/, "00").padStart(2, "0");
  const validHours = validate(String(hours), /^([01]?[0-9]|2[0-3])$/, "00").padStart(2, "0");
  const validDayOfMonth = validate(String(dayOfMonth), /^([1-9]|[12][0-9]|3[01]|\*)$/, "?");
  const validMonth = validate(String(month), /^(1[0-2]|[1-9]|\*)$/, "*");
  let validDayOfWeek = validate(String(dayOfWeek), /^([0-6]|\?|L|#)$/, "?");

  if (validDayOfMonth !== "?") validDayOfMonth.padStart(2, "0");
  if (validMonth !== "?") validMonth.padStart(2, "0");
  if (validDayOfMonth === "?" && validDayOfWeek === "?") validDayOfWeek = "*";
  if (validDayOfWeek !== "?" && validDayOfWeek !== "*") validDayOfWeek.padStart(2, "0");

  return `${validSeconds} ${validMinutes} ${validHours} ${validDayOfMonth} ${validMonth} ${validDayOfWeek}`;
};

export const getCronFrequency = (cronExpression: string): CurrentSchedule => {
  if (cronExpression === "") return { frequency: "inactive" };
  const [__, minute, hour, dayOfMonth, _, dayOfWeek] = cronExpression.split(" ");

  if (dayOfMonth !== "?" && dayOfMonth !== "*") {
    return { frequency: "monthly", dayOfMonth: +dayOfMonth, time: `${hour}:${minute}` };
  }
  if (dayOfWeek !== "?" && dayOfWeek !== "*" && dayOfWeek !== "00" && dayOfWeek !== "07") {
    return { frequency: "weekly", dayOfWeek: +dayOfWeek, time: `${hour}:${minute}` };
  }
  if (dayOfMonth === "?" && dayOfWeek === "*") {
    return { frequency: "daily", time: `${hour}:${minute}` };
  }
  return { frequency: "inactive" };
};

export const getStartEndDate = (dateRange: string): { startDate: string; endDate: string } => {
  const dates = dateRange.split(" - ");

  if (!dates[0] || !dates[1]) {
    return { startDate: "", endDate: "" };
  }

  const start = moment(+dates[0]).utcOffset(Constants.uaeTimezone);
  const end = moment(+dates[1]).utcOffset(Constants.uaeTimezone);

  const startYear = start.year();
  const startMonth = (start.month() + 1).toString().padStart(2, "0");

  const endYear = end.year();
  const endMonth = (end.month() + 1).toString().padStart(2, "0");

  return {
    startDate: `${startYear}${startMonth}`,
    endDate: `${endYear}${endMonth}`,
  };
};

const validate = (value: string, pattern: RegExp, defaultValue: string): string => {
  return pattern.test(value) ? value : defaultValue;
};
